import {
  onboardingDropdownsApi,
  TGetCrudParams,
} from 'onboarding/classes/services/api/OnboardingDropdownsApi'

class DropdownsService {
  public getCrud(params: TGetCrudParams) {
    return onboardingDropdownsApi.getCrud(params)
  }
}

export const dropdownsService = new DropdownsService()
